import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lm-facade-toggle-button',
  standalone: false,
  template: `
    <div class="lm-view-toggle">
      <div class="lm-view-buttons-wrapper">
        <div class="lm-toggle-btn-wrapper"
             [class.lm-toggle-selected]="viewTilesSelected"
        ><svg class="lm-toggle-btn"
              soho-icon
              (click)="viewClicked('tiles')"
              [icon]="'grid'"
              soho-tooltip
              [content]="'Tiles' | translate"/>
        </div>
        <div class="lm-toggle-btn-wrapper"
             [class.lm-toggle-selected]="viewGridSelected"
        ><svg class="lm-toggle-btn"
              soho-icon
              (click)="viewClicked('grid')"
              [icon]="'unorderedlist'"
              soho-tooltip
              [content]="'ListLabel' | translate"/>
        </div>
      </div>
    </div>
  `,
  styleUrl: './lm-facade-toggle-button.component.scss',
})
export class LMFacadeToggleButtonComponent {

  @Output() toggleButtonClicked: EventEmitter<'grid' | 'tiles'> = new EventEmitter<'grid' | 'tiles'>();

  public viewTilesSelected = true;
  public viewGridSelected = false;

  constructor(  ) {
  }

  viewClicked(view: 'grid' | 'tiles'): void {
    this.viewGridSelected = this.viewTilesSelected = false;
    if (view === 'grid')
      this.viewGridSelected = true;
    else
      this.viewTilesSelected = true;

    this.toggleButtonClicked.emit(view);
  }

}
